import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options   tracking-unit options for the chosen material
 *   onChange  the caller clears the dependent density alongside
 *   rules     RHF rules; the shipment form pairs it with the tracking density
 */
export const TrackingUnitField = ({ options = EMPTY_LIST, onChange, rules }) => {
  const t = useTranslations();

  return (
    <Field name="trackingUnit" rules={rules}>
      {({ id, name, value, onBlur, status, message }) => (
        <Dropdown
          id={id}
          name={name}
          label={t('SHIPMENT_FORM_TRACKING_UNIT')}
          placeholder={t('FORM_SELECT_UNIT')}
          emptyMessage={t('FORM_SELECT_MATERIAL_FIRST')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          options={options}
        />
      )}
    </Field>
  );
};
